import { Link } from "react-router-dom";
import { Gauge } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { formatInt, lazyPage } from "@vixio/ui";
import "./api";
import { ImgResultsPage, useImgKpis } from "./ResultsPage";
import { ImgTemplatesPage } from "./TemplatesPage";

export * from "./api";
export { ScoreBar } from "./ResultsPage";
export { templateProblem, renderSample } from "./TemplatesPage";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const ImgResultPage = lazyPage(() => import("./ResultPage"), "ImgResultPage");

function ImgWidget() {
  const org = useOrg();
  const k = useImgKpis(org.id).data;
  return (
    <dl className="vx-dl">
      <dt>Últimos 30 dias</dt>
      <dd className="num">{formatInt(k?.last30 ?? 0)}</dd>
      {(k?.byStage ?? []).map((s) => (
        <div key={s.key} style={{ display: "contents" }}>
          <dt>{s.label}</dt>
          <dd className="num">{formatInt(s.n)}</dd>
        </div>
      ))}
      <dt />
      <dd>
        <Link to="/diagnostico/img">Abrir resultados do IMG</Link>
      </dd>
    </dl>
  );
}

export default defineModuleUi({
  key: "img",
  title: "IMG",
  domain: "diagnostics",
  icon: Gauge,
  menu: [{ path: "/diagnostico/img", label: "IMG", minRole: "member", icon: Gauge, order: 10, keywords: "maturidade gerencial diagnóstico devolutiva estágio utm" }],
  routes: [
    { path: "/diagnostico/img", element: <ImgResultsPage />, minRole: "member" },
    { path: "/diagnostico/img/devolutiva", element: <ImgTemplatesPage />, minRole: "member" },
    { path: "/diagnostico/img/:id", element: <ImgResultPage />, minRole: "member" },
  ],
  widgets: [{ key: "img.results", title: "IMG respondidos", minRole: "member", span: 1, order: 30, element: ImgWidget }],
});
